var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import StitchError from "./StitchError";
import { StitchServiceErrorCode } from "./StitchServiceErrorCode";

var StitchServiceError = function (_super) {
  __extends(StitchServiceError, _super);

  function StitchServiceError(message, errorCode) {
    if (errorCode === void 0) {
      errorCode = StitchServiceErrorCode.Unknown;
    }

    var _this = _super.call(this, message) || this;

    _this.message = message;
    _this.errorCode = errorCode;
    _this.errorCodeName = StitchServiceErrorCode[errorCode];
    return _this;
  }

  return StitchServiceError;
}(StitchError);

export default StitchServiceError;